import { createCommand, LexicalCommand } from 'lexical';

export interface TentativeItemPayload {
  label: string;
  editId: string;
}

export interface ElementSelectedPayload {
  editId: string;
  label: string;
}

// Low-level commands (used internally by state machine)
export const INSERT_TENTATIVE_ITEM_COMMAND: LexicalCommand<TentativeItemPayload> = 
  createCommand('INSERT_TENTATIVE_ITEM_COMMAND');

export const REMOVE_ALL_TENTATIVE_COMMAND: LexicalCommand<void> = 
  createCommand('REMOVE_ALL_TENTATIVE_COMMAND');

export const CONVERT_TENTATIVE_TO_PERMANENT_COMMAND: LexicalCommand<void> = 
  createCommand('CONVERT_TENTATIVE_TO_PERMANENT_COMMAND');

// High-level event commands (dispatched from outside)
export const ELEMENT_SELECTED_COMMAND: LexicalCommand<ElementSelectedPayload> = 
  createCommand('ELEMENT_SELECTED_COMMAND');

export const INPUT_FOCUSED_COMMAND: LexicalCommand<void> = 
  createCommand('INPUT_FOCUSED_COMMAND');

export const EDIT_MODE_EXITED_COMMAND: LexicalCommand<void> = 
  createCommand('EDIT_MODE_EXITED_COMMAND');

